import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { createStructuredSelector } from 'reselect';
import { requestDeviceUpdate, } from 'console/redux/devices/items/actions';
import { pickDevice } from 'console/redux/main-actions';
import { DeviceCard } from './device-card';
import { deActivateZTHDashboard } from './actions';
import { eligableDevice } from './utils';
import './zth-dashboard.sass';
import { selectDevicesFields } from 'entities/device/lib';
function ZTHDashboardImpl(props) {
    const { account_id, devices, server_time, config, onGoToDevice, onModeChange } = props;
    return (_jsx("div", { className: "zth-dashboard", children: _jsx("div", { className: "ui-cards-container", children: devices.map((device) => {
                if (eligableDevice(account_id, device)) {
                    const device_id = device.id;
                    return (_jsx(DeviceCard, { device: device, server_time: server_time, config: config, onGoToDevice: () => onGoToDevice(device_id), onModeChange: (mode_id) => onModeChange(device_id, mode_id) }, device.id));
                }
                return null;
            }) }) }));
}
export const ZTHDashboard = connect(createStructuredSelector({
    account_id: (state) => state.account.id,
    server_time: (state) => state.server_time,
    config: (state) => state.account.zth_dashboard,
    devices: createSelector(selectDevicesFields([
        'id',
        'name',
        'device_type',
        'capabilities',
        'thermostat_enabled',
        'guard_state',
        'user_id',
        'access',
        'firmware_version',
        'thermometers',
        'rf_status',
        'online',
        'stationary_location',
        'internet_weather',
        'use_internet_weather_for_pza',
        'pza',
        'thermostat_ext_modes_config',
        'thermostat_ext_mode',
        'thermostat_target_temps',
        'last_boiler_state',
        'thermostat_enable_guard',
        'iconState',
        'timezone',
    ]), (devices) => devices),
}), (dispatch) => ({
    onGoToDevice: (device_id) => {
        dispatch(pickDevice(device_id));
        dispatch(deActivateZTHDashboard());
    },
    onModeChange: (device_id, mode_id) => {
        dispatch(requestDeviceUpdate(device_id, {
            thermostat_ext_mode: mode_id,
        }));
    },
}))(ZTHDashboardImpl);
